import React, { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, TextareaField, Tag, Iconsvg, ButtonFieldIcon } from '@wk/components-react16';
import { Toast } from '../../services';

const AddRunBatch = ({ data }: any) => {
    const { isOpenRunBatch, setIsOpenRunBatch, tryNowdocumentBatchList, setTryNowdocumentBatchList } = data;
    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenRunBatch(false);
        }
    }

    const handleBatchDocument = (value: any, id: any) => {
        /* tryNowdocumentBatchList.forEach((item: any) => {
            if (item.id == id) {
                item.isSelected = value;
            }
        }); */
        tryNowdocumentBatchList.find((item: any) => item.id == id).isSelected = value;
        const newBatchDocument = [...tryNowdocumentBatchList];
        setTryNowdocumentBatchList(newBatchDocument);
    }


    const handleRunBatch = () => {
        if (tryNowdocumentBatchList.filter((item: any) => item.isSelected).length === 0) {
            Toast("Please select atleast one document.", "error")
            return;
        }
        setIsOpenRunBatch(false);
    }

    return (
        <div className='custom-modal'>
            <Modal
                isOpen={isOpenRunBatch}
                srLabelledBy={'modal-id-runbatch'}
                srDescribedBy={'modal-id-runbatch'}
                width={'80%'} onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-runbatch'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    Select Document
                </ModalHeader>
                <ModalBody descriptionId="modal-id-runbatch">
                    <div className='mb-20 pt-20 position-relative'>
                        {tryNowdocumentBatchList.length > 0 ? tryNowdocumentBatchList.map((item: any, index: any) => (
                            item.status && (
                                <div key={item.id} className='r-card mb-10 position-relative'>
                                    <input className="r-card-checkbox" type="checkbox" id={item.id} value={item.isSelected} checked={item.isSelected} onChange={(e: any) => handleBatchDocument(e.target.checked, item.id)} />
                                    <div className={`r-card-body ${item.isSelected ? 'checked' : ''}`}>
                                        <div className={`r-card-body-icon ${item.isSelected ? 'checked' : ''}`}>
                                            <Iconsvg name="check" size={24} color="#005b92"></Iconsvg>
                                        </div>
                                        <h5 className='r-card-body-title mb-0'>
                                            <div className="d-flex">
                                                <span className="card-title2 mr-10">
                                                    <Iconsvg size={18} name={item.type == 'pdf' ? 'file-pdf' : 'file-excel'}></Iconsvg>
                                                </span>
                                                <div className='wrap-text wk-size-4'>
                                                    {item.name}
                                                </div>
                                            </div>
                                        </h5>
                                    </div>
                                </div>
                            )
                        )) : (
                            <table className='center'>
                                <tbody><tr>
                                    <td>
                                        <h5>No documents available.</h5>
                                    </td>
                                </tr></tbody>
                            </table>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'text'}>
                                <button
                                    type="button"
                                    id="cancel"
                                onClick={() => handleUserRequest('footer')}>
                                    Close
                                </button>
                            </ButtonField>
                                <ButtonField>
                                    <button
                                        type="button"
                                        id="defaultClose"
                                        onClick={() => handleRunBatch()}>
                                        Select
                                    </button>
                                </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddRunBatch;